"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Root;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _ = require(".."); //


function Root(_ref) {
  var children = _ref.children;

  var ResolvedRoot = _react["default"].useMemo(function () {
    return _.plugins.Root(function (_ref2) {
      var children = _ref2.children;
      return children;
    });
  }, [_.plugins]);

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      error = _React$useState2[0],
      setError = _React$useState2[1];

  _react["default"].useEffect(function () {
    if (module && module.hot) {
      var hotReloadHandler = function hotReloadHandler(status) {
        if (status === 'idle') {
          setError(null);
        }
      };

      module.hot.addStatusHandler(hotReloadHandler);
      return function () {
        module.hot.removeStatusHandler(hotReloadHandler);
      };
    }
  });

  return _react["default"].createElement(Catch, {
    onCatch: setError
  }, error ? _react["default"].createElement("pre", {
    style: {
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      background: '#222',
      color: 'white',
      margin: 0,
      padding: '1rem',
      overflow: 'scroll',
      fontSize: '14px'
    }
  }, "An internal error occured!\n\n".concat(process.env.NODE_ENV === 'production' ? 'Please see the console for more details.' : error.stack, "\n          ")) : _react["default"].createElement(ResolvedRoot, null, children));
}

var Catch = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Catch, _React$Component);

  function Catch() {
    (0, _classCallCheck2["default"])(this, Catch);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Catch).apply(this, arguments));
  }

  (0, _createClass2["default"])(Catch, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      this.props.onCatch(error);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return Catch;
}(_react["default"].Component);